import { createRuntimeConfigGet } from './createRuntimeConfigGet';
import { RuntimeConfig } from './types';

export type { RuntimeConfig };

declare global {
    interface Window {
        __RUNTIME_CONFIG__?: RuntimeConfig;
    }
}

function getStore(): RuntimeConfig {
    const config = window.__RUNTIME_CONFIG__;

    if (!config) {
        throw new Error('RuntimeConfig is not set');
    }

    return config;
}

export const runtimeConfig = {
    get: createRuntimeConfigGet(getStore),
};
